module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', {
    attrs: {
      "dark": ""
    }
  }, [_c('app-header'), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: (_vm.onScroll),
      expression: "onScroll"
    }],
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('router-view', {
    attrs: {
      "id": "routerView"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.offsetTop >= 200) ? _c('v-btn', {
    staticClass: "mt-5 darken-2",
    attrs: {
      "fixed": "",
      "dark": "",
      "fab": "",
      "bottom": "",
      "right": "",
      "color": "orange"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.scrollTop($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    }
  }, [_vm._v("keyboard_arrow_up")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.snackbarMessage != '') ? _c('v-snackbar', {
    attrs: {
      "color": _vm.snackbarColor,
      "vertical": ""
    },
    model: {
      value: (_vm.messagebar),
      callback: function($$v) {
        _vm.messagebar = $$v
      },
      expression: "messagebar"
    }
  }, [_vm._v("               \n            " + _vm._s(_vm.snackbarMessage) + "\n            "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.setMessagebar(false)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15a3e64d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 310
// module chunks = 0